// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"2606a6b1","453":"e1d31f16","455":"e1e5b421"}[chunkId] + ".chunk.js";
};